import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

export function useDeleteVariableMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      await fetchApi({
        endpoint: `/api/variables/delete/${id}`,
        method: 'DELETE',
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['variables', 'list'] })
      void queryClient.invalidateQueries({ queryKey: ['variables', 'all'] })
    },
  })
}
